// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__4xszb","mobileAboutContainer":"About_mobileAboutContainer__piZmi","aboutContentContainer":"About_aboutContentContainer__afVcp"};